<template>
    <div v-if="item" class="ms-item ms-item-colors" :class="`ms-item-depth-${depth}`" :id="`ms-item-${item.id}`" >
        <div class="ms-left-highlight"></div>
        <div class="ms-header ms-header-colors round-left" :class="`ms-header-depth-${depth}`" >
            <div class="ms-left-highlight">
            </div>
            <div class="ms-icon" v-if="item.title_icon" >
                <img :id="`ms-toggle-btn-${item.id}`" :src="item.title_icon" @click="toggle1" >
            </div>
            <div class="ms-title" :class="`ms-title-depth-${depth}`" v-if="item.title" >
                <span v-if="item.title" >{{item.title}}</span>
                <span v-if="(item.title && item.subtitle)">-</span>
                <span v-if="item.subtitle">{{item.subtitle}}</span>
                <span v-if="(item.vernum && item.title)">-</span>
                <span v-if="item.vernum">{{item.vernum}}</span>
            </div>
            <div class="ms-preview ms-preview-colors round-all" :style="`background: url('${item.preview}'); background-size: cover;`" v-if="item.preview" >
                <!--img class="ms-preview-img round-all" :src='item.preview'  -->
            </div>
        </div>
        <div :id="`ms-main-toggle-${item.id}`" style="{max-height:10000px;}" class="ms-main-toggle" >
            <div class="ms-main round-left" v-if="(item.description || content || items)">
                <div class="ms-vernum-date-time" v-if="(item.vernum || item.date || item.time)">
                    <span class="ms-vernum" v-if="item.vernum">V {{item.vernum}} | </span>
                    <span class="ms-date" v-if="item.date">{{item.date}}</span>
                    <span v-if="(item.date && item.time)">|</span>
                    <span class="ms-time" v-if="item.time" >{{item.time}}</span>
                </div>
                <div class="ms-authorship" v-if="(item.project || item.aspect || item.author)" >
                    <span class="ms-project" v-if="item.project" >{{item.project}}</span>
                    <span v-if="((item.project || item.aspect) && item.author)">&mdash;</span>
                    <span class="ms-aspect" v-if="item.aspect" >{{item.aspect}}</span>
                    <span class="ms-author" v-if="item.author" >{{item.author}}</span>
                </div>
                <div class="ms-description" v-if="item.description">{{item.description}}</div>
                <div class="ms-content-html" v-if="content" v-html="content"></div>
                <div class="ms-child-items-wrapper above-1 round-left-more" v-if="items">
                    <div class="flex-container round-left-more" v-if="items">
                        <StreamX v-for="i in items" :key="i.id" :index="i.id" :item="i" v-on:play="play" :depth="depth + 1" :loadItems="true"></StreamX>
                    </div>
                </div>
            </div>
        </div>
        <div :id="`ms-footer-toggle-${item.id}`" style="{max-height:1000px;}" class="ms-footer-toggle">
            <div class="ms-footer" v-if="footer" v-html="footer"></div>
            <div class="ms-data-footer ms-bottom" v-if="(item.content_url || item.items_ids || item.footer_url)">({{itemId}},{{item.id}})&ensp;|&ensp;{{item.content_url}}&ensp;|&ensp;{{item.items_ids}}&ensp;|&ensp;{{item.footer_url}}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StreamX from './StreamX.vue'
import fixUrls from '../fixUrls'

export default {
    name: 'StreamX',
    data: function () {
        return {
            m_content_loading: false,
            m_footer_loading: false,
            content: null,
            footer: null,
            items: [],
        }
    },
    props: [ 'itemId', 'item', 'depth', 'loadItems', 'loadHtmls','baseUrl'],
    components: {
        'StreamX': StreamX
    },
    created: function () {
        this.fetchData();
    },
    methods: {
        toggle1: function() {
            this.toggle2(`ms-main-toggle-${this.item.id}`,`ms-toggle-btn-${this.item.id}`,"10000px");
            this.toggle2(`ms-footer-toggle-${this.item.id}`,`ms-toggle-btn-${this.item.id}`,"1000px");
        },
        toggle2: function(showHideDiv, switchTextDiv, maxHeight) {
            const ele = document.getElementById(showHideDiv);
            /* const text = document.getElementById(switchTextDiv); */
            if (ele) {
                if(ele.style.maxHeight == "0px") {
                    ele.style.maxHeight = maxHeight;
                } else {
                    ele.style.maxHeight = "0px";
                }
            }
        },
        fetchItems: function (type,items_ids) {
            if (!items_ids || !type) return;
            this.$store
            .dispatch('LOAD_STREAMS', { ids:items_ids, name:type+'.json'})
            .then(() => {
                this.items = this.getStateByIds(type,items_ids);
            });
        },
        fetchHtml: function (type,id,name) {
            if (!id || !type || !name) return;
            this.$store
            .dispatch('LOAD_HTML', { type, id, name } )
            .then(() => {
                this[type] = this.getStateById(type,id);
            });
        },
        fetchData: function () {
            if ( this.loadItems != false) 
                this.fetchItems("stream", this.item.items_ids);
            if ( this.loadHtmls != false) {
                if (this.item.footer_url)
                    this.fetchHtml("footer",this.item.id, this.item.footer_url);
                if (this.item.content_url)                    
                    this.fetchHtml("content",this.item.id, this.item.content_url);
            }
        },
        play: function (url) {
            this.$emit("play", url)
        },
    },
    computed: {
        ...mapGetters({
            getStateById: 'getStateById',
            getStateByIds: 'getStateByIds',
        })
    },
    watch: {
        item: function (val) {
            console.log('item changed');
        },
        items: function (val) {
            console.log('items changed');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/StreamX.vue